import React, { useState } from "react";
import { Box, Tabs as MUITabs, TabsProps, SxProps } from "@mui/material";
import { useTheme } from "contexts";

type Props = TabsProps & {
  currentTab: number;
};

export const Tabs = ({
  value,
  onChange,
  currentTab,
  children,
  ...rest
}: Props) => {
  const { theme } = useTheme();

  return (
    <MUITabs
      value={currentTab}
      onChange={onChange}
      sx={{
        // p: theme.spacing.xs,
        borderRadius: theme.border.radius,
        minHeight: theme.component.layout.tab.height,
        "& .MuiTabs-indicator": {
          border: 1,
          zIndex: 0,
          height: 1,
          transition: "all 300ms ease",
          backgroundColor: "transparent",
          borderRadius: theme.border.radius,
          borderColor: theme.color.accent.color,
        },
        "& .MuiTab-root": {
          transition: "300ms",
          px: theme.spacing.md,
          textTransform: "none",
          color: theme.color.font.accent,
          fontWeight: theme.font.medium,
          borderRadius: theme.border.radius,
          minHeight: theme.component.layout.tab.height,
          "&.Mui-selected": {
            color: theme.color.accent.color,
          },
        },
      }}
    >
      {children}
    </MUITabs>
  );
};

interface TabContentProps {
  index: number;
  value: number;
  children?: React.ReactNode;
}

export const TabContent = ({
  children,
  value,
  index,
  ...rest
}: TabContentProps) => {
  return (
    <Box component="div" hidden={value !== index} {...rest}>
      {value === index && children}
    </Box>
  );
};
